<template>
    <div class="row">
      <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <barangay-form @save="getBarangays()" v-if="showForm" :barangay="selected"></barangay-form>
          </div>
        </div>
  
      </el-drawer>
  
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">Manage Barangays</div>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
              <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="barangays" style="width: 100%">
  
              <el-table-column :min-width="120"  class-name="td-actions" label="Code">
                <template slot-scope="props">
                  {{ props.row.code }}<br>
                </template>
              </el-table-column>
              <el-table-column :min-width="120"  class-name="td-actions" label="Name">
                <template slot-scope="props">
                  {{ props.row.name }}<br>
                </template>
              </el-table-column>

              <el-table-column :min-width="120"  class-name="td-actions" label="Voters">
                <template slot-scope="props">
                  {{ props.row.voters_count }}<br>
                </template>
              </el-table-column>
  
    
              <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
                <template slot-scope="props">
  
                  <el-button type="primary" link @click="handleManage(props.row)" size="mini">
                    Manage <i class="fa fa-eyey"></i>
                  </el-button>

                  <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                    <i class="fa fa-edit"></i>
                  </el-button>
                  <confirm-button @onClick="handleRemoveVoterActions(props.row)" :title="'Remove voter actions?'" icon="fa fa-times"></confirm-button>
                  <confirm-delete @onClick="handleDelete(props.row)" :label="''"></confirm-delete>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Found {{ pagination.total }} data</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  import { Barangay } from '@/resources/barangay'
  import ConfirmDelete from '../../Common/ConfirmDelete.vue'
import BarangayForm from './BarangayForm.vue'
import ConfirmButton from '../../Common/ConfirmButton.vue'
  
  export default {
    components: { ConfirmDelete, BarangayForm, ConfirmButton },
    data() {
        return {
        loading: false,
        showForm: false,
        barangays: [],
        selected: null,
        perPageOptions: [5, 10, 15],
        pagination: {
          perPage: 999,
          currentPage: 1,
          total: 0
        },
        term: null,
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getBarangays()
        }
      },
      'pagination.perPage': function () {
        if (this.pagination.currentPage == 1) {
          this.getBarangays()
        } else {
          this.pagination.currentPage = 1
        }
      },
      'pagination.currentPage': function () {
        this.getBarangays()
      }
    },
    created: function () {
      this.getBarangays()
    },
    methods: {
      handleManage(model) {
        this.$router.push({name: 'BarangayView', params:{id: model.id}})
      },
      handleEdit(model) {
        this.showForm = true
        this.selected = Object.assign({}, model)
      },
      handleClose() {
        this.showDelete = false
        this.showForm = false
      },
      handleForm() {
        this.showForm = true
        this.selected = null
      },
      handleRemoveVoterActions(model){
        this.loading = true
  
        Barangay.removeVoterActions(model.id)
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter actions for this barangay have been removed',
            });
            this.getBarangays()
          })
          .catch(() => {

          }).finally(() => {
            this.loading = false
          })
      },
      handleDelete(model) {
        this.loading = true
  
        Barangay.delete(model.id)
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Barangay has been removed',
            });
            this.getBarangays()
          })
          .catch(() => {
  
          }).finally(() => {
            this.loading = false
          })
      },
      getBarangays() {
        this.handleClose()
        let params = { term: this.term, status: this.status, page: this.pagination.currentPage, per_page: this.pagination.perPage }
        this.loading = true
        Barangay.get(params)
          .then(result => {
            this.pagination = result.data.meta
            if (result.data.barangays)
              this.barangays = result.data.barangays
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch barangays',
            });
  
          }).finally(() => {
            this.$loading = false
          })
      }
    }
  }
  </script>
  <style lang="scss"></style>
  